import { Component, inject } from '@angular/core';
import { DistributionService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DistributionCreateDto,
  DistributionDto,
  DistributionExcelDownloadDto,
  DistributionUpdateDto,
} from '../proxy/planning/dtos/distribution';
import { DISTRIBUTION_CONFIG, DISTRIBUTION_FIELDS } from './distribution.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-distribution',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DistributionService, ConfirmationService],
  templateUrl: './distribution.html',
  styleUrl: './distribution.scss',
})
export class Distribution extends BaseCrudComponent<
  DistributionDto,
  DistributionCreateDto,
  DistributionUpdateDto,
  DistributionExcelDownloadDto
> {
  service = inject(DistributionService);
  config = DISTRIBUTION_CONFIG;
  fields = DISTRIBUTION_FIELDS;

  protected prepareUpdateDto(data: any, selected: DistributionDto): DistributionUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Distribution';
  }
}
